import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportHubService } from '../../../services/report-hub.service';
import { ReportJobsService } from '../../../services/report-jobs.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-registered-data-reports',
  templateUrl: './registered-data-reports.component.html',
  styleUrls: ['./registered-data-reports.component.scss']
})
export class RegisteredDataReportsComponent implements OnInit, OnDestroy {
  loading = false;
  private reportHubSub!: Subscription;
  private pendingJobId: string | null = null;

  constructor(
    private _reportJobsService: ReportJobsService,
    private _reportHubService: ReportHubService,
    private _toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.reportHubSub = this._reportHubService.reportStatusChanged$.subscribe(notification => {
      if (notification.jobId !== this.pendingJobId) return;
      if (notification.status === 'Completed') {
        this.loading = false;
        this._toastService.showToast('success', 'Reporte generado. Descargando...');
        this._reportJobsService.downloadReport(notification.jobId, notification.fileName || undefined);
        this.pendingJobId = null;
      } else if (notification.status === 'Failed') {
        this.loading = false;
        this._toastService.showToast('error', `Error al generar el reporte: ${notification.errorMessage || 'Desconocido'}`);
        this.pendingJobId = null;
      } else if (notification.status === 'Processing') {
        this._toastService.showToast('info', 'Procesando datos registrados...');
      }
    });
  }

  ngOnDestroy(): void { this.reportHubSub?.unsubscribe(); }

  download(): void {
    this.loading = true;
    this._reportJobsService.queueRegisteredData().subscribe({
      next: (r) => {
        this.pendingJobId = r.jobId;
        this._toastService.showToast('info', 'Generando reporte en segundo plano...');
      },
      error: () => {
        this.loading = false;
        this._toastService.showToast('error', 'Error al solicitar el reporte.');
      }
    });
  }
}
